import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "dinolab",
    description: "dinolab is a creative digital marketing studio. Branding, websites, social media, ads and SEO that make your brand impossible to ignore.",
    url: getOrigin()
}
